import classNames from 'classnames'

export const classModule = function (styles, ...classList) {
    let ary = [];
    if (classList.length) {
        classList[0] instanceof Array ? ary = classList[0] : ary = classList
    }
    const classnameList = ary.map(cla => styles[cla] || cla);
    return classNames(classnameList)
}
export const classModuleGenerator = function (styles) {
    return function (...classList) {
        return classModule(styles, classList?.[0] instanceof Array ? classList[0] : classList)
    }
}

const util = {
    classModule,
    classModuleGenerator
}

export default util